export const LOGIN = "prevenx/auth/LOGIN"
export const LOGOUT = "prevenx/auth/LOGOUT"
export const VERIFY_TOKEN = "prevenx/auth/VERIFY_TOKEN"
export const RESET_PASSWORD = "prevenx/auth/RESET_PASSWORD"
export const MESSAGE = "prevenx/auth/MESSAGE"
export const DISMISS_MESSAGE = "prevenx/auth/DISMISS_MESSAGE"
export const GET_USER_INFO_SUCCESS = "prevenx/auth/GET_USER_INFO_SUCCESS"
export const GET_USER_INFO_ERROR = "prevenx/auth/GET_USER_INFO_ERROR"